import { render, staticRenderFns } from "./CaseNumber.vue?vue&type=template&id=1a430ea5&scoped=true&"
import script from "./CaseNumber.vue?vue&type=script&lang=ts&"
export * from "./CaseNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a430ea5",
  null
  
)

export default component.exports